import { useEffect } from "react"

/**
 * A convenience method for adding and cleaning up event listeners.
 *
 * @param {DOMElement} target
 * @param {string} event
 * @param {function} callback
 */
export default (target, event, callback) => {
  return useEffect(() => {
    target.addEventListener(event, callback)

    return () => {
      target.removeEventListener(event, callback)
    }
  }, [callback])
}
